export default __webpack_public_path__ + "static/media/hvac.b6e56145.jpg";